// Object rotation snap in degrees
export const OBJECT_ROTATION_SNAP_THRESHOLD = 5;
